// a user visible error, so that its message can be safely shown to the user
export class ClientError extends Error {}
